<template>
  <vx-card
    class="cardx"
    remove-card-action
    :title="title"
    title-color="primary"
    @remove="$emit('remove')"
  >
    <div class="vx-row mb-4">
      <div
        class="vx-col mb-4 w-full md:w-1/2"
        v-show="lodash.get(tracking, 'id')"
      >
        <vs-input
          class="w-full"
          label="Created By"
          :value="tracking.created_by"
          color="dark"
          disabled
        />
      </div>

      <div
        class="vx-col mb-4 w-full md:w-1/2"
        v-show="lodash.get(tracking, 'id')"
      >
        <vs-input
          class="w-full"
          label="Created At"
          :value="createdAt"
          color="dark"
          disabled
        />
      </div>

      <div class="vx-col mb-4 w-full">
        <label class="vs-input--label">Worknote</label>
        <vs-textarea
          v-model="tracking.notes"
          class="mb-0"
          label="Fill your work note here..."
          name="worknote"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm block mt-2"
          v-show="errors.has('worknote')"
        >
          {{ errors.first('worknote') }}
        </span>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <label class="vs-input--label">Status</label>
        <div class="vs-con-input mt-2">
          <ul class="flex">
            <li class="mx-1">
              <vs-radio
                v-model="tracking.status"
                vs-value="follow_up"
                name="status"
                v-validate="'required'"
              >
                Follow Up
              </vs-radio>
            </li>
            <li class="mx-1">
              <vs-radio
                v-model="tracking.status"
                vs-value="complete"
                name="status"
                v-validate="'required'"
              >
                Complete
              </vs-radio>
            </li>
            <li class="mx-1">
              <vs-radio
                v-model="tracking.status"
                vs-value="call_fail"
                name="status"
                v-validate="'required'"
              >
                Call Fail
              </vs-radio>
            </li>
            <li class="mx-1">
              <vs-radio
                v-model="tracking.status"
                vs-value="unable_contact"
                name="status"
                v-validate="'required'"
              >
                Unable To Contact
              </vs-radio>
            </li>
          </ul>
        </div>
        <span
          class="text-danger text-sm block mt-2"
          v-show="errors.has('status')"
        >
          {{ errors.first('status') }}
        </span>
      </div>

      <div
        class="vx-col mb-4 w-full md:w-1/2"
        v-if="
          tracking.status === 'follow_up' || tracking.status === 'call_fail'
        "
      >
        <label class="vs-input--label">Next Follow Up Date</label>
        <datepicker
          v-model="tracking.follow_up_at"
          placeholder="Select Date"
          name="follow_up_at"
          color="dark"
          class="w-full"
          :config="configDateTimePicker"
        />
        <span
          class="text-danger text-sm block mt-2"
          v-show="errors.has('follow_up_at')"
        >
          {{ errors.first('follow_up_at') }}
        </span>
      </div>
    </div>

    <hr class="my-4" />
    <div class="vx-col w-full text-center">
      <vs-button @click.prevent="submit" class="mx-1"> Save </vs-button>
      <vs-button
        type="border"
        color="warning"
        @click.prevent="$emit('remove')"
        class="mx-1"
      >
        Cancel
      </vs-button>
    </div>
  </vx-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate.js'
import 'flatpickr/dist/plugins/confirmDate/confirmDate.css'
import schemas from '@/utils/schemas'

export default {
  name: 'Tracking',
  filters: {
    labelCode(value) {
      return value.map(({ id, title }) => ({
        label: title,
        code: id
      }))
    }
  },
  data: () => ({
    schema: schemas.stoolTracking(),
    tracking: schemas.stoolTracking(),
    dateFormat: 'DD MMM YYYY HH:mm',
    configDateTimePicker: {
      enableTime: true,
      dateFormat: 'd M Y H:i',
      time_24hr: true,
      plugins: [new ConfirmDatePlugin()]
    }
  }),
  components: {
    Datepicker
  },
  computed: {
    ...mapGetters('stoolTracking', {
      $tracking: 'info'
    }),
    ...mapGetters('stoolQuestionnaire', ['profile']),

    title() {
      if (
        !this.lodash.isEmpty(this.lodash.get(this.tracking, 'tracking_number'))
      ) {
        return `Tracking #${this.tracking.tracking_number}`
      }
      return 'New Tracking'
    },

    createdAt() {
      if (this.lodash.get(this.tracking, 'created_at')) {
        return this.$moment(
          this.lodash.get(this.tracking, 'created_at')
        ).format('LLL')
      }

      return this.$moment().format('LLL')
    }
  },
  methods: {
    ...mapActions('stoolQuestionnaire', {
      fetchProfile: 'find'
    }),

    ...mapActions('stoolTracking', ['updateOrCreate']),
    validate() {
      return this.$validator.validateAll()
    },
    codeReducer({ code }) {
      return code
    },
    customFormatter(date) {
      return this.$moment(date).format(this.dateFormat)
    },
    async submit() {
      const valid = await this.validate()

      if (valid) {
        this.$vs.loading()

        try {
          await this.updateOrCreate({
            id: this.profile.id,
            trackingId: this.tracking.id,
            tracking: this.tracking
          })

          this.$vs.notify({
            title: 'Success',
            text: 'Tracking has been created',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })

          this.$emit('success')
          this.$emit('remove')
        } catch (error) {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          this.$emit('fail')
        } finally {
          this.$vs.loading.close()
        }
      }
    }
  },

  async mounted() {
    if (
      this.lodash.isObject(this.$tracking) &&
      !this.lodash.isNull(this.lodash.get(this.$tracking, 'id'))
    ) {
      this.$store.commit(
        'stoolTracking/SET_INFO',
        this.lodash.pick(this.$tracking, Object.keys(this.schema))
      )
    }
  },

  watch: {
    $tracking() {
      if (!this.lodash.isObject(this.tracking)) {
        this.lodash.set(this, 'tracking', schemas.tracking())
      }

      Object.assign(
        this.tracking,
        this.lodash.pick(this.$tracking, Object.keys(this.schema))
      )

      if (this.tracking.follow_up_at !== null) {
        this.tracking.follow_up_at = this.customFormatter(
          this.tracking.follow_up_at
        )
      }
    }
  }
}
</script>
